import { Component, OnInit } from '@angular/core';
//import { PushNotificationService } from './push-notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ia360';

  //constructor(public pushService: PushNotificationService) {}

  ngOnInit() {
    
  }

  subscribe() {
    //this.pushService.subscribeToNotifications();
  }
  
}
